import React, { useState } from 'react';
import { X } from 'lucide-react';
import { api } from '../services/api';

interface PatientModalProps {
  isVisible: boolean;
  onClose: () => void;
  onPatientAdded: (patient: any) => void;
}

export const PatientModal: React.FC<PatientModalProps> = ({
  isVisible,
  onClose,
  onPatientAdded,
}) => {
  const [newPatientName, setNewPatientName] = useState('');
  const [isAddingPatient, setIsAddingPatient] = useState(false);

  const handleAddPatient = async () => {
    if (!newPatientName.trim()) return;

    try {
      setIsAddingPatient(true);
      const newPatient = await api.createPatient(newPatientName.trim());
      onPatientAdded(newPatient);
      setNewPatientName('');
      onClose();
    } catch (error) {
      console.error('Error adding patient:', error);
    } finally {
      setIsAddingPatient(false);
    }
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black/30 backdrop-blur-[1px] flex items-center justify-center z-50">
      <div className="bg-base-100 rounded-lg shadow-xl border border-base-300 w-full max-w-md mx-4">
        <div className="flex items-center justify-between p-6 border-b border-base-300">
          <h3 className="text-lg font-semibold text-base-content">Add New Patient</h3>
          <button
            type="button"
            onClick={onClose}
            className="btn btn-ghost btn-sm btn-circle"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="p-6">
          <label htmlFor="newPatientName" className="label">
            <span className="label-text font-medium text-base-content">Patient Name</span>
          </label>
          <input
            id="newPatientName"
            type="text"
            value={newPatientName}
            onChange={(e) => setNewPatientName(e.target.value)}
            placeholder="Enter patient name"
            className="input input-bordered w-full mt-2"
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                handleAddPatient();
              }
            }}
          />
        </div>
        <div className="flex justify-end gap-3 p-6 border-t border-base-300">
          <button
            type="button"
            onClick={onClose}
            className="btn btn-outline"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleAddPatient}
            disabled={!newPatientName.trim() || isAddingPatient}
            className="btn btn-primary"
          >
            {isAddingPatient ? 'Adding...' : 'Add Patient'}
          </button>
        </div>
      </div>
    </div>
  );
}; 